
import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/img/logo.png";
import { DataContext } from "../context/DataContext";
import Notification from "./Notification";

function TopHeader() {
  const result = useContext(DataContext);
  const employee = result?.employeeData;

  const notificationRef = useRef(null);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();

  const [showDropdown, setShowDropdown] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);

  const userName = employee?.firstName
    ? employee.firstName.charAt(0).toUpperCase() +
      employee.firstName.slice(1)
    : "";

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="navbar-container top-header">

        {/* LEFT: LOGO */}
        <div className="navbar-logo header-logo">
          <img
            src={logo}
            alt="Fship Logo"
            className="header-brand-img error-logo-light"
          />
        </div>

        {/* RIGHT: HEADER ACTIONS */}
        <div className="header-right">

          {/* NOTIFICATION */}
          <div
            className="header-notification"
            onClick={() => notificationRef.current?.show()}
            role="button"
            title="Notifications"
          >
            <i className="fa fa-bell"></i>

            {notificationCount > 0 && (
              <span className="notification-badge">
                {notificationCount > 99
                  ? "99+"
                  : notificationCount}
              </span>
            )}
          </div>

          {/* USER PROFILE */}
          <div className="header-user" ref={dropdownRef}>
            <div
              className="header-profile"
              onClick={() => setShowDropdown((prev) => !prev)}
              role="button"
            >
              <span className="header-welcome">
                Welcome, <strong>{userName}</strong>
              </span>

              <i className="fa fa-user-circle user-icon"></i>

              <i
                className={`fa fa-chevron-down dropdown-arrow ${
                  showDropdown ? "active" : ""
                }`}
              ></i>
            </div>

            {/* LOGOUT DROPDOWN */}
            {showDropdown && (
              <div className="header-dropdown">
                <div
                  className="dropdown-item"
                  onClick={handleLogout}
                >
                  <i className="fa fa-sign-out me-2"></i>
                  Logout
                </div>
              </div>
            )}
          </div>

        </div>
      </div>

      <Notification
        ref={notificationRef}
        onCountChange={setNotificationCount}
      />
    </>
  );
}

export default TopHeader;
